// skills/smithing/smithingData.js
// Smithing bars and configuration

export const BARS = {
    PYRESTONE: {
        id: 'pyrestone',
        name: 'Pyrestone Bar',
        level: 1,
        xp: 12.5,
        baseTime: 3000,
        inputItem: 'pyrestone_ore',
        inputQuantity: 1,
        drops: [
            { itemId: 'pyrestone_bar', weight: 1, quantity: 1 }
        ],
        color: '#cd7f32'
    },
    PALE_SHARD: {
        id: 'pale_shard',
        name: 'Pale Shard Bar',
        level: 15,
        xp: 25,
        baseTime: 3500,
        inputItem: 'pale_shard_ore',
        inputQuantity: 1,
        drops: [
            { itemId: 'pale_shard_bar', weight: 1, quantity: 1 }
        ],
        color: '#c0c0c0'
    },
    BLACKIRON: {
        id: 'blackiron',
        name: 'Blackiron Bar',
        level: 30,
        xp: 37.5,
        baseTime: 4000,
        inputItem: 'blackiron_ore',
        inputQuantity: 1,
        secondaryItem: 'deepcoal',
        secondaryQuantity: 2,
        drops: [
            { itemId: 'blackiron_bar', weight: 1, quantity: 1 }
        ],
        color: '#2d2d2d'
    },
    GOLD: {
        id: 'gold',
        name: 'Gold Bar',
        level: 40,
        xp: 56.2,
        baseTime: 4500,
        inputItem: 'gold_ore',
        inputQuantity: 1,
        drops: [
            { itemId: 'gold_bar', weight: 1, quantity: 1 }
        ],
        color: '#ffd700'
    },
    SKYIRON: {
        id: 'skyiron',
        name: 'Skyiron Bar',
        level: 50,
        xp: 50,
        baseTime: 5000,
        inputItem: 'skyiron_ore',
        inputQuantity: 1,
        drops: [
            { itemId: 'skyiron_bar', weight: 1, quantity: 1 }
        ],
        color: '#4169e1'
    },
    VERDANT_CORE: {
        id: 'verdant_core',
        name: 'Verdant Core Bar',
        level: 55,
        xp: 62.5,
        baseTime: 6000,
        inputItem: 'verdant_core_ore',
        inputQuantity: 1,
        drops: [
            { itemId: 'verdant_core_bar', weight: 1, quantity: 1 }
        ],
        color: '#228b22'
    },
    VOIDSTEEL: {
        id: 'voidsteel',
        name: 'Voidsteel Bar',
        level: 70,
        xp: 75,
        baseTime: 7000,
        inputItem: 'voidsteel_ore',
        inputQuantity: 1,
        secondaryItem: 'deepcoal',
        secondaryQuantity: 4,
        drops: [
            { itemId: 'voidsteel_bar', weight: 1, quantity: 1 }
        ],
        color: '#00ced1'
    }
};

// Arrow heads for woodworking ammunition
export const ARROW_HEADS = {
    PYRESTONE: {
        id: 'pyrestone_arrowheads',
        name: 'Pyrestone Arrowheads',
        level: 1,
        xp: 7.5,
        baseTime: 2000,
        inputItem: 'pyrestone_bar',
        inputQuantity: 1,
        drops: [
            { itemId: 'pyrestone_arrowheads', weight: 1, quantity: 15 }
        ],
        color: '#cd7f32'
    },
    PALE_SHARD: {
        id: 'pale_shard_arrowheads',
        name: 'Pale Shard Arrowheads',
        level: 15,
        xp: 15,
        baseTime: 2500,
        inputItem: 'pale_shard_bar',
        inputQuantity: 1,
        drops: [
            { itemId: 'pale_shard_arrowheads', weight: 1, quantity: 15 }
        ],
        color: '#c0c0c0'
    },
    BLACKIRON: {
        id: 'blackiron_arrowheads',
        name: 'Blackiron Arrowheads',
        level: 30,
        xp: 25,
        baseTime: 3000,
        inputItem: 'blackiron_bar',
        inputQuantity: 1,
        drops: [
            { itemId: 'blackiron_arrowheads', weight: 1, quantity: 15 }
        ],
        color: '#2d2d2d'
    },
    SKYIRON: {
        id: 'skyiron_arrowheads',
        name: 'Skyiron Arrowheads',
        level: 45,
        xp: 35,
        baseTime: 3500,
        inputItem: 'skyiron_bar',
        inputQuantity: 1,
        drops: [
            { itemId: 'skyiron_arrowheads', weight: 1, quantity: 15 }
        ],
        color: '#4169e1'
    },
    VERDANT_CORE: {
        id: 'verdant_core_arrowheads',
        name: 'Verdant Core Arrowheads',
        level: 60,
        xp: 50,
        baseTime: 4000,
        inputItem: 'verdant_core_bar',
        inputQuantity: 1,
        drops: [
            { itemId: 'verdant_core_arrowheads', weight: 1, quantity: 15 }
        ],
        color: '#228b22'
    },
    VOIDSTEEL: {
        id: 'voidsteel_arrowheads',
        name: 'Voidsteel Arrowheads',
        level: 75,
        xp: 65,
        baseTime: 4500,
        inputItem: 'voidsteel_bar',
        inputQuantity: 1,
        drops: [
            { itemId: 'voidsteel_arrowheads', weight: 1, quantity: 15 }
        ],
        color: '#00ced1'
    }
};

// Melee weapons - swords crafted from bars
export const SWORDS = {
    PYRESTONE: {
        id: 'pyrestone_sword',
        name: 'Pyrestone Sword',
        level: 5,
        xp: 25,
        baseTime: 4000,
        inputItem: 'pyrestone_bar',
        inputQuantity: 3,
        drops: [
            { itemId: 'pyrestone_sword', weight: 1, quantity: 1 }
        ],
        color: '#cd7f32'
    },
    PALE_SHARD: {
        id: 'pale_shard_sword',
        name: 'Pale Shard Sword',
        level: 20,
        xp: 50,
        baseTime: 5000,
        inputItem: 'pale_shard_bar',
        inputQuantity: 3,
        drops: [
            { itemId: 'pale_shard_sword', weight: 1, quantity: 1 }
        ],
        color: '#c0c0c0'
    },
    BLACKIRON: {
        id: 'blackiron_sword',
        name: 'Blackiron Sword',
        level: 35,
        xp: 75,
        baseTime: 6000,
        inputItem: 'blackiron_bar',
        inputQuantity: 3,
        drops: [
            { itemId: 'blackiron_sword', weight: 1, quantity: 1 }
        ],
        color: '#2d2d2d'
    },
    SKYIRON: {
        id: 'skyiron_sword',
        name: 'Skyiron Sword',
        level: 50,
        xp: 100,
        baseTime: 7000,
        inputItem: 'skyiron_bar',
        inputQuantity: 3,
        drops: [
            { itemId: 'skyiron_sword', weight: 1, quantity: 1 }
        ],
        color: '#4169e1'
    },
    VERDANT_CORE: {
        id: 'verdant_core_sword',
        name: 'Verdant Core Sword',
        level: 65,
        xp: 125,
        baseTime: 8000,
        inputItem: 'verdant_core_bar',
        inputQuantity: 3,
        drops: [
            { itemId: 'verdant_core_sword', weight: 1, quantity: 1 }
        ],
        color: '#228b22'
    },
    VOIDSTEEL: {
        id: 'voidsteel_sword',
        name: 'Voidsteel Sword',
        level: 80,
        xp: 150,
        baseTime: 9000,
        inputItem: 'voidsteel_bar',
        inputQuantity: 4,
        drops: [
            { itemId: 'voidsteel_sword', weight: 1, quantity: 1 }
        ],
        color: '#00ced1'
    }
};

// Dirks - fast, weak melee daggers (1 bar each)
export const DIRKS = {
    PYRESTONE: {
        id: 'pyrestone_dirk',
        name: 'Pyrestone Dirk',
        level: 1,
        xp: 10,
        baseTime: 2000,
        inputItem: 'pyrestone_bar',
        inputQuantity: 1,
        drops: [{ itemId: 'pyrestone_dirk', weight: 1, quantity: 1 }],
        color: '#cd7f32',
        tier: 1
    },
    PALE_SHARD: {
        id: 'pale_shard_dirk',
        name: 'Pale Shard Dirk',
        level: 15,
        xp: 20,
        baseTime: 2500,
        inputItem: 'pale_shard_bar',
        inputQuantity: 1,
        drops: [{ itemId: 'pale_shard_dirk', weight: 1, quantity: 1 }],
        color: '#c0c0c0',
        tier: 2
    },
    BLACKIRON: {
        id: 'blackiron_dirk',
        name: 'Blackiron Dirk',
        level: 30,
        xp: 35,
        baseTime: 3000,
        inputItem: 'blackiron_bar',
        inputQuantity: 1,
        drops: [{ itemId: 'blackiron_dirk', weight: 1, quantity: 1 }],
        color: '#2d2d2d',
        tier: 3
    },
    SKYIRON: {
        id: 'skyiron_dirk',
        name: 'Skyiron Dirk',
        level: 45,
        xp: 50,
        baseTime: 3500,
        inputItem: 'skyiron_bar',
        inputQuantity: 1,
        drops: [{ itemId: 'skyiron_dirk', weight: 1, quantity: 1 }],
        color: '#4169e1',
        tier: 4
    },
    VERDANT_CORE: {
        id: 'verdant_core_dirk',
        name: 'Verdant Core Dirk',
        level: 60,
        xp: 70,
        baseTime: 4000,
        inputItem: 'verdant_core_bar',
        inputQuantity: 1,
        drops: [{ itemId: 'verdant_core_dirk', weight: 1, quantity: 1 }],
        color: '#228b22',
        tier: 5
    },
    VOIDSTEEL: {
        id: 'voidsteel_dirk',
        name: 'Voidsteel Dirk',
        level: 75,
        xp: 90,
        baseTime: 4500,
        inputItem: 'voidsteel_bar',
        inputQuantity: 1,
        drops: [{ itemId: 'voidsteel_dirk', weight: 1, quantity: 1 }],
        color: '#00ced1',
        tier: 6
    }
};

// Greatswords - slow, powerful 2H melee weapons (5 bars each)
export const GREATSWORDS = {
    PYRESTONE: {
        id: 'pyrestone_greatsword',
        name: 'Pyrestone Greatsword',
        level: 10,
        xp: 50,
        baseTime: 6000,
        inputItem: 'pyrestone_bar',
        inputQuantity: 5,
        drops: [{ itemId: 'pyrestone_greatsword', weight: 1, quantity: 1 }],
        color: '#cd7f32',
        tier: 1
    },
    PALE_SHARD: {
        id: 'pale_shard_greatsword',
        name: 'Pale Shard Greatsword',
        level: 25,
        xp: 100,
        baseTime: 7500,
        inputItem: 'pale_shard_bar',
        inputQuantity: 5,
        drops: [{ itemId: 'pale_shard_greatsword', weight: 1, quantity: 1 }],
        color: '#c0c0c0',
        tier: 2
    },
    BLACKIRON: {
        id: 'blackiron_greatsword',
        name: 'Blackiron Greatsword',
        level: 40,
        xp: 150,
        baseTime: 9000,
        inputItem: 'blackiron_bar',
        inputQuantity: 5,
        drops: [{ itemId: 'blackiron_greatsword', weight: 1, quantity: 1 }],
        color: '#2d2d2d',
        tier: 3
    },
    SKYIRON: {
        id: 'skyiron_greatsword',
        name: 'Skyiron Greatsword',
        level: 55,
        xp: 200,
        baseTime: 10500,
        inputItem: 'skyiron_bar',
        inputQuantity: 5,
        drops: [{ itemId: 'skyiron_greatsword', weight: 1, quantity: 1 }],
        color: '#4169e1',
        tier: 4
    },
    VERDANT_CORE: {
        id: 'verdant_core_greatsword',
        name: 'Verdant Core Greatsword',
        level: 70,
        xp: 250,
        baseTime: 12000,
        inputItem: 'verdant_core_bar',
        inputQuantity: 5,
        drops: [{ itemId: 'verdant_core_greatsword', weight: 1, quantity: 1 }],
        color: '#228b22',
        tier: 5
    },
    VOIDSTEEL: {
        id: 'voidsteel_greatsword',
        name: 'Voidsteel Greatsword',
        level: 85,
        xp: 300,
        baseTime: 13500,
        inputItem: 'voidsteel_bar',
        inputQuantity: 5,
        drops: [{ itemId: 'voidsteel_greatsword', weight: 1, quantity: 1 }],
        color: '#00ced1',
        tier: 6
    }
};

// Melee armor tier configuration
const MELEE_TIER_CONFIG = {
    1: { prefix: 'pyrestone', name: 'Pyrestone', barId: 'pyrestone_bar', color: '#cd7f32', baseLevel: 1 },
    2: { prefix: 'pale_shard', name: 'Pale Shard', barId: 'pale_shard_bar', color: '#c0c0c0', baseLevel: 15 },
    3: { prefix: 'blackiron', name: 'Blackiron', barId: 'blackiron_bar', color: '#2d2d2d', baseLevel: 30 },
    4: { prefix: 'skyiron', name: 'Skyiron', barId: 'skyiron_bar', color: '#4169e1', baseLevel: 45 },
    5: { prefix: 'verdant_core', name: 'Verdant Core', barId: 'verdant_core_bar', color: '#228b22', baseLevel: 60 },
    6: { prefix: 'voidsteel', name: 'Voidsteel', barId: 'voidsteel_bar', color: '#00ced1', baseLevel: 75 }
};

// Armor slot configuration: slot -> { name, bars, levelOffset, xpMultiplier }
const ARMOR_SLOT_CONFIG = {
    gloves: { name: 'Gauntlets', bars: 2, levelOffset: 2, xpMult: 0.8, timeMult: 0.7 },
    boots: { name: 'Sabatons', bars: 2, levelOffset: 3, xpMult: 0.8, timeMult: 0.7 },
    helm: { name: 'Helm', bars: 3, levelOffset: 4, xpMult: 1.0, timeMult: 0.9 },
    shoulders: { name: 'Pauldrons', bars: 3, levelOffset: 5, xpMult: 1.0, timeMult: 0.9 },
    chestplate: { name: 'Chestplate', bars: 5, levelOffset: 8, xpMult: 1.5, timeMult: 1.2 },
    legguards: { name: 'Platelegs', bars: 4, levelOffset: 6, xpMult: 1.2, timeMult: 1.0 }
};

// Generate melee armor recipes for all tiers
function generateMeleeArmorRecipes() {
    const recipes = {};

    for (let tier = 1; tier <= 6; tier++) {
        const tierConfig = MELEE_TIER_CONFIG[tier];
        recipes[tier] = {};

        for (const [slot, slotConfig] of Object.entries(ARMOR_SLOT_CONFIG)) {
            const itemId = `${tierConfig.prefix}_${slot}`;
            const level = tierConfig.baseLevel + slotConfig.levelOffset;
            const baseXp = 15 + (tier - 1) * 15; // 15, 30, 45, 60, 75, 90 base XP per tier
            const baseTime = 3000 + (tier - 1) * 500; // 3000, 3500, 4000, 4500, 5000, 5500 base time

            recipes[tier][slot.toUpperCase()] = {
                id: itemId,
                name: `${tierConfig.name} ${slotConfig.name}`,
                level: level,
                xp: Math.round(baseXp * slotConfig.xpMult),
                baseTime: Math.round(baseTime * slotConfig.timeMult),
                inputItem: tierConfig.barId,
                inputQuantity: slotConfig.bars,
                drops: [{ itemId: itemId, weight: 1, quantity: 1 }],
                color: tierConfig.color,
                tier: tier,
                slot: slot
            };
        }
    }

    return recipes;
}

export const MELEE_ARMOR = generateMeleeArmorRecipes();

// Tier info for UI (name, level, color, barId for icon display)
export const MELEE_TIERS = {
    1: { name: 'Pyrestone', level: 1, color: '#cd7f32', barId: 'pyrestone_bar' },
    2: { name: 'Pale Shard', level: 15, color: '#c0c0c0', barId: 'pale_shard_bar' },
    3: { name: 'Blackiron', level: 30, color: '#2d2d2d', barId: 'blackiron_bar' },
    4: { name: 'Skyiron', level: 45, color: '#4169e1', barId: 'skyiron_bar' },
    5: { name: 'Verdant Core', level: 60, color: '#228b22', barId: 'verdant_core_bar' },
    6: { name: 'Voidsteel', level: 75, color: '#00ced1', barId: 'voidsteel_bar' }
};

// Bulwarks - melee offhand shields (defense + HP + block)
export const BULWARKS = {
    PYRESTONE: {
        id: 'pyrestone_bulwark',
        name: 'Pyrestone Bulwark',
        level: 15,
        xp: 30,
        baseTime: 5000,
        inputItem: 'pyrestone_bar',
        inputQuantity: 4,
        drops: [{ itemId: 'pyrestone_bulwark', weight: 1, quantity: 1 }],
        color: '#cd7f32',
        tier: 1
    },
    PALE_SHARD: {
        id: 'pale_shard_bulwark',
        name: 'Pale Shard Bulwark',
        level: 30,
        xp: 60,
        baseTime: 6000,
        inputItem: 'pale_shard_bar',
        inputQuantity: 4,
        drops: [{ itemId: 'pale_shard_bulwark', weight: 1, quantity: 1 }],
        color: '#c0c0c0',
        tier: 2
    },
    BLACKIRON: {
        id: 'blackiron_bulwark',
        name: 'Blackiron Bulwark',
        level: 45,
        xp: 90,
        baseTime: 7000,
        inputItem: 'blackiron_bar',
        inputQuantity: 5,
        drops: [{ itemId: 'blackiron_bulwark', weight: 1, quantity: 1 }],
        color: '#2d2d2d',
        tier: 3
    },
    SKYIRON: {
        id: 'skyiron_bulwark',
        name: 'Skyiron Bulwark',
        level: 60,
        xp: 120,
        baseTime: 8000,
        inputItem: 'skyiron_bar',
        inputQuantity: 5,
        drops: [{ itemId: 'skyiron_bulwark', weight: 1, quantity: 1 }],
        color: '#4169e1',
        tier: 4
    },
    VERDANT_CORE: {
        id: 'verdant_core_bulwark',
        name: 'Verdant Core Bulwark',
        level: 75,
        xp: 150,
        baseTime: 9000,
        inputItem: 'verdant_core_bar',
        inputQuantity: 6,
        drops: [{ itemId: 'verdant_core_bulwark', weight: 1, quantity: 1 }],
        color: '#228b22',
        tier: 5
    },
    VOIDSTEEL: {
        id: 'voidsteel_bulwark',
        name: 'Voidsteel Bulwark',
        level: 90,
        xp: 180,
        baseTime: 10000,
        inputItem: 'voidsteel_bar',
        inputQuantity: 6,
        drops: [{ itemId: 'voidsteel_bulwark', weight: 1, quantity: 1 }],
        color: '#00ced1',
        tier: 6
    }
};

// Get all equipment for a tier (dirk, armor pieces, sword, bulwark, greatsword)
export function getEquipmentForTier(tier) {
    const tierKey = ['PYRESTONE', 'PALE_SHARD', 'BLACKIRON', 'SKYIRON', 'VERDANT_CORE', 'VOIDSTEEL'][tier - 1];
    const armorRecipes = MELEE_ARMOR[tier] || {};

    // Order: dirk, gloves, boots, helm, bulwark, shoulders, sword, chestplate, legguards, greatsword
    const equipment = [];

    // Add dirk first (lowest level)
    if (DIRKS[tierKey]) equipment.push({ ...DIRKS[tierKey], type: 'dirk' });

    // Add armor in order
    if (armorRecipes.GLOVES) equipment.push({ ...armorRecipes.GLOVES, type: 'armor' });
    if (armorRecipes.BOOTS) equipment.push({ ...armorRecipes.BOOTS, type: 'armor' });
    if (armorRecipes.HELM) equipment.push({ ...armorRecipes.HELM, type: 'armor' });

    // Add bulwark (offhand shield)
    if (BULWARKS[tierKey]) equipment.push({ ...BULWARKS[tierKey], type: 'bulwark' });

    if (armorRecipes.SHOULDERS) equipment.push({ ...armorRecipes.SHOULDERS, type: 'armor' });

    // Add sword (mid-tier)
    if (SWORDS[tierKey]) equipment.push({ ...SWORDS[tierKey], type: 'sword', tier: tier });

    // Add remaining armor
    if (armorRecipes.LEGGUARDS) equipment.push({ ...armorRecipes.LEGGUARDS, type: 'armor' });
    if (armorRecipes.CHESTPLATE) equipment.push({ ...armorRecipes.CHESTPLATE, type: 'armor' });

    // Add greatsword last (highest level)
    if (GREATSWORDS[tierKey]) equipment.push({ ...GREATSWORDS[tierKey], type: 'greatsword' });

    return equipment;
}

export const TOOLS = {
    PYRESTONE: {
        id: 'pyrestone_hammer',
        name: 'Pyrestone Hammer',
        level: 1,
        speedMultiplier: 1.0,
        price: 0
    },
    PALE_SHARD: {
        id: 'pale_shard_hammer',
        name: 'Pale Shard Hammer',
        level: 15,
        speedMultiplier: 1.2,
        price: 1000
    },
    BLACKIRON: {
        id: 'blackiron_hammer',
        name: 'Blackiron Hammer',
        level: 30,
        speedMultiplier: 1.4,
        price: 5000
    },
    SKYIRON: {
        id: 'skyiron_hammer',
        name: 'Skyiron Hammer',
        level: 45,
        speedMultiplier: 1.6,
        price: 25000
    },
    VERDANT: {
        id: 'verdant_hammer',
        name: 'Verdant Hammer',
        level: 60,
        speedMultiplier: 1.8,
        price: 100000
    },
    VOIDSTEEL: {
        id: 'voidsteel_hammer',
        name: 'Voidsteel Hammer',
        level: 75,
        speedMultiplier: 2.0,
        price: 250000
    }
};

export default {
    BARS,
    ARROW_HEADS,
    SWORDS,
    DIRKS,
    GREATSWORDS,
    BULWARKS,
    MELEE_ARMOR,
    MELEE_TIERS,
    getEquipmentForTier,
    TOOLS
};
